module.exports = __webpack_public_path__ + "static/media/personal-info.f02a04a5.png";